module.exports = __webpack_public_path__ + "static/media/optima-seguros-phone.e422439f.svg";